import FilterListIcon from '@mui/icons-material/FilterList';
import RefreshIcon from '@mui/icons-material/Refresh';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useSnackbar } from 'notistack';
import React from 'react';
import { errorSnackbar } from '../../ErrorSnackbar';

type ColumnFiltersProps = {
  filtering: boolean;
  setFiltering: React.Dispatch<React.SetStateAction<boolean>>;
};

export function RefreshButton<Data>({
  refetch,
  isLoading,
}: {
  refetch: () => Promise<Data | null>;
  isLoading?: boolean;
}) {
  const { closeSnackbar, enqueueSnackbar } = useSnackbar();

  const onRefresh = React.useCallback(() => {
    refetch().catch((err) => {
      errorSnackbar('Unable to refresh table data', closeSnackbar, enqueueSnackbar, err);
    });
  }, [closeSnackbar, enqueueSnackbar, refetch]);

  return (
    <Tooltip title="Refresh">
      <IconButton onClick={onRefresh} disabled={isLoading} size="large">
        {isLoading ? <CircularProgress size={24} /> : <RefreshIcon />}
      </IconButton>
    </Tooltip>
  );
}

export const ColumnFiltersToggle: React.FC<ColumnFiltersProps> = ({ filtering, setFiltering }) => (
  <Tooltip title={`${filtering ? 'Disable' : 'Enable'} column filters`}>
    <IconButton onClick={() => setFiltering((prev) => !prev)} size="large">
      <FilterListIcon />
    </IconButton>
  </Tooltip>
);
